






















import Vue from 'vue'
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import Event from '../model/Event';
import {State} from 'vuex-class';
import {notify} from '@/modules/core/notification';

/**
 * Dialogo que solicita al usuario confirmación para eliminar el evento seleccionado
 */
@Component
export default class ConfirmEventDelete extends Vue {
    /**
     * Evento que será eliminado
     */
    @State(state => state.reservation.currentEvent)
    public event: Event

    /**
     * Controla la visibilidad del dialogo
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    public loading = false
    public error = ''

    @Watch('value')
    public watchValue () {
        this.error = ''
    }

    /**
     * Procede a eliminar el evento en el servidor
     */
    public async remove () {
        const event = this.event
        this.loading = true
        await this.$store.dispatch('reservation/deleteEvent', this.event.id)

        this.loading = false
        this.$emit('input', false)

        notify(`El evento ${event.name} ha sido eliminado correctamente`)
    }

    public close () {
        this.$emit('input', false)
        this.error = ''
    }

    public errorCaptured (error: Error) {
        this.loading = false
        this.error = error.message
    }
}
